export class AppState {
    static currentState = "active"
    static addEventListener = (arg1, arg2) => { } // App state never changes on web
    static removeEventListener = (arg1, arg2) => { } // App state never changes on web
}